import React from "react";
import styles from "./EmptyState.module.css";

/** Icon in a circle, a title, a line of body copy, one button. */
export const EmptyState = ({ icon, title, body, action, onAction }) => (
  <div className={styles.wrap}>
    <span className={styles.icon} aria-hidden="true">{icon}</span>
    <p className={styles.title}>{title}</p>
    {body && <p className={styles.body}>{body}</p>}
    {action && (
      <button type="button" className={styles.button} onClick={onAction}>
        {action}
      </button>
    )}
  </div>
);

export const CartIcon = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 6h15l-1.5 9h-12z" />
    <circle cx="9" cy="20" r="1.4" />
    <circle cx="18" cy="20" r="1.4" />
    <path d="M6 6L5 3H2" />
  </svg>
);

export default EmptyState;
